import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import FavoriteStarButton from '../../../components/favorites/FavoriteStarButton';
import { FAVORITE_TYPE_USER } from '../../../services/favoriteModelsService';
import { cn } from '../../../utils/cn';
import { DOCUMENT_TITLE_WRAP_CLASS } from '../../../utils/documentTitle';

const formatDateTime = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const TemplateCardMobile = ({
  template,
  onEdit,
  onCreateContract,
  onDelete,
  onDuplicate,
  onDownload,
  actionsDisabled = false,
}) => {
  const canDownload =
    Boolean(template.templateKey ?? template.template_key) &&
    String(template.docx_status ?? '').toUpperCase() === 'GENERATED';

  return (
    <div className="list-item-hover list-item-hover-card rounded-lg p-4 shadow-elevation-sm hover:shadow-elevation-md transition-smooth border bg-muted/10 border-muted-foreground/25">
      <div className="flex items-start gap-3 mb-3">
        <div className="flex items-center justify-center w-12 h-12 rounded-lg flex-shrink-0 bg-muted/50">
          <Icon
            name="LayoutTemplate"
            size={24}
            className="text-muted-foreground"
          />
        </div>

        <div className="flex-1 min-w-0">
          <h3
            className={cn(
              'text-base font-semibold text-foreground font-heading mb-1',
              DOCUMENT_TITLE_WRAP_CLASS
            )}
            title={template.name}
          >
            {template.name}
          </h3>

          {template.description ? (
            <p className="text-sm text-muted-foreground font-body line-clamp-2">
              {template.description}
            </p>
          ) : null}
        </div>
      </div>

      <div className="mb-4">
        <p className="text-xs text-muted-foreground font-caption mb-1">
          Data de Criação
        </p>
        <p className="text-sm text-foreground font-body">
          {formatDateTime(template.created_at)}
        </p>
      </div>

      <div className="pt-3 border-t border-border">
        <p className="text-xs text-muted-foreground font-caption mb-2">
          Ações
        </p>

        <div className="flex flex-wrap items-center justify-end gap-2">
          <FavoriteStarButton
            type={FAVORITE_TYPE_USER}
            id={template.template_id ?? template.id}
          />

          <Button
            variant="ghost"
            size="sm"
            iconName="FilePlus"
            onClick={() => onCreateContract(template)}
            disabled={actionsDisabled}
            className="transition-transform hover:scale-110"
            aria-label="Gerar documento com este modelo"
            title="Gerar documento"
          />

          <Button
            variant="ghost"
            size="sm"
            iconName="Download"
            onClick={() => onDownload(template)}
            disabled={actionsDisabled || !canDownload}
            className="transition-transform hover:scale-110"
            aria-label="Baixar modelo DOCX"
            title="Baixar modelo DOCX"
          />

          <Button
            variant="ghost"
            size="sm"
            iconName="Edit"
            onClick={() => onEdit(template)}
            disabled={actionsDisabled}
            className="transition-transform hover:scale-110"
            aria-label="Editar modelo"
            title="Editar modelo"
          />

          <Button
            variant="ghost"
            size="sm"
            iconName="Copy"
            onClick={() => onDuplicate(template)}
            disabled={actionsDisabled}
            className="transition-transform hover:scale-110"
            aria-label="Duplicar modelo"
            title="Duplicar modelo"
          />

          <Button
            variant="ghost"
            size="sm"
            iconName="Trash2"
            onClick={() => onDelete(template)}
            disabled={actionsDisabled}
            className="text-destructive hover:text-destructive transition-transform hover:scale-110"
            aria-label="Excluir modelo"
            title="Excluir modelo"
          />
        </div>
      </div>
    </div>
  );
};

export default TemplateCardMobile;
